import { Component, Input, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EquityPageDataService } from '../../../../services/equity-page-data.service';

export interface CardModel {
  headline: string;
  backgroundUrl: string;
  text: string;
  icon: string;
  button: {
    name: string;
    url: string;
  };
}

@Component({
  selector: 'customer-app-equity-card-item',
  templateUrl: './equity-card-item.component.html',
  styleUrls: ['./equity-card-item.component.scss'],
  standalone: false
})
export class EquityCardItemComponent {
  private domSanitizer = inject(DomSanitizer);
  equityPageDataService = inject(EquityPageDataService);

  @Input() card: CardModel;
  readonly small = input<boolean>(undefined);

  get iconUrl(): string {
    return `assets/equity/icons/general/${this.card?.icon}.svg`;
  }

  onButtonClick(button): void {
    if (button.url) {
      window.open(button.url, '_blank');
    } else if (button.program) {
      this.equityPageDataService.displayPage({ fileName: button.program });
    }
  }

  getSanitizedUrl(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
